import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";


export interface LoginHistoryItem {
  id: number;
  date: string;
  device: string;
  ip: string;
}

export interface LoginHistoryProps {
  loginHistory?: LoginHistoryItem[];
}

const LoginHistory: React.FC<LoginHistoryProps> = ({ loginHistory: propLoginHistory }) => {
  const defaultHistoryData = [
    {
      id: 1,
      loginTime: "2025-03-01 09:15 AM",
      ipAddress: "192.168.1.15",
      device: "Chrome - Windows 10",
      status: "Success",
    },
    {
      id: 2,
      loginTime: "2025-02-28 08:40 PM",
      ipAddress: "192.168.1.22",
      device: "Safari - iPhone 14",
      status: "Failed",
    },
    {
      id: 3,
      loginTime: "2025-02-28 07:10 PM",
      ipAddress: "192.168.1.45",
      device: "Edge - Windows 11",
      status: "Success",
    },
  ];

  // Transform prop data to match table structure
  const historyData = propLoginHistory
    ? propLoginHistory.map((item, index) => ({
      id: item.id || index + 1,
      loginTime: item.date,
      ipAddress: item.ip,
      device: item.device,
      status: "Success",
    }))
    : defaultHistoryData;
  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>

              <TableCell>Login Time</TableCell>
              <TableCell>IP Address</TableCell>
              <TableCell>Device</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {historyData.map((row, index) => (
              <TableRow key={row.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.loginTime}</TableCell>
                <TableCell>{row.ipAddress}</TableCell>
                <TableCell>{row.device}</TableCell>
                <TableCell>{row.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default LoginHistory;
